export type UpdateProjectResponse = {};
